import GoalsAPI from 'dashboard/api/goals';

const state = {
  records: [],
  uiFlags: { isFetching: false, isSaving: false },
};

const getters = {
  getGoals: s => s.records,
  getUIFlags: s => s.uiFlags,
};

const mutations = {
  SET_GOALS(state, goals) { state.records = goals; },
  ADD_GOAL(state, goal) { state.records.push(goal); },
  REMOVE_GOAL(state, id) { state.records = state.records.filter(g => g.id !== id); },
  SET_UI_FLAG(state, flags) { state.uiFlags = { ...state.uiFlags, ...flags }; },
};

const actions = {
  async fetch({ commit }, userId) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await GoalsAPI.getGoals(userId);
      commit('SET_GOALS', data);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, payload) {
    const { data } = await GoalsAPI.create(payload);
    commit('ADD_GOAL', data);
    return data;
  },
  async sync({ commit }, { userId, goals }) {
    commit('SET_UI_FLAG', { isSaving: true });
    try {
      const { data } = await GoalsAPI.sync(userId, goals);
      commit('SET_GOALS', data);
    } finally {
      commit('SET_UI_FLAG', { isSaving: false });
    }
  },
  async destroy({ commit }, goalId) {
    await GoalsAPI.destroy(goalId);
    commit('REMOVE_GOAL', goalId);
  },
};

export default { namespaced: true, state, getters, mutations, actions };
